import { type FC } from "react";
import { Select, MenuItem, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const OPTIONS = [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 500];

interface ChangeLimitProps {
  limit: number;
  setLimit: (limit: number) => void;
}

export const ChangeLimit: FC<ChangeLimitProps> = ({ limit, setLimit }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography variant="body2">{t("shared.changeLimit.rows")}</Typography>
      <Select
        value={limit}
        onChange={(event) => setLimit(Number(event.target.value))}
        variant="standard"
        disableUnderline
      >
        {OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};
